export default class KeyValue {
    constructor() {
        this.id = null;
        this.key = '';
        this.values = {
            1: '', // Portuguese
            2: '', // English  
            3: ''  // Spanish
        };
    }

    // Helper method to get value for specific language
    getValue(language) {
        return this.values[language] || '';
    }

    // Helper method to set value for specific language
    setValue(language, value) {
        this.values[language] = value;
    }

    // Helper method to check if all values are the same
    areAllValuesSame() {
        const values = Object.values(this.values);
        return values.every(value => value === values[0]);
    }

    // Helper method to set all values to the same value
    setAllValues(value) {
        this.values = {
            1: value, // Portuguese
            2: value, // English
            3: value  // Spanish
        };
    }
}
